import OLLayerGroup from 'ol/layer/Group'

import * as PoziUtils from 'api/utils'
import { setLayerUnselected } from 'drawer/tabs/layers/actions'
// import UnSelectLayer from 'drawer/tabs/layers/utils/UnSelectLayer'

export default function UnSelectOtherLayersInGroup (titleid, groupid) {
  // console.debug('UnSelectOtherLayersInGroup', titleid, groupid)

  const olLayers = PoziUtils.getAllOLLayersAndGroups()
  olLayers.forEach(function (olLayer, idx, arr) {
    const titleidCompare = olLayer.get('titleid')
    if (!titleidCompare) {
      return
    }

    const layerConfCompare = PoziUtils.getLayerFromTitleID(titleidCompare)
    if (!layerConfCompare) {
      return
    }

    if (layerConfCompare.groupid === groupid && layerConfCompare.titleid !== titleid && layerConfCompare.selected) {
      console.debug('UnSelectOtherLayersInGroup - unselecting', layerConfCompare.titleid)

      // Currently the redux action calls UnSelectLayer, where it should be the other way around
      // UnSelectLayer(layerCompare.titleid)
      window.store.dispatch(setLayerUnselected(layerConfCompare.titleid))
    }
  })
}
